<div class="layout">
  <aside>
    <p class="uppercase font-bold"> {{ title }} </p>
    <hr>
    <span *ngFor="let item of menuItems">
      <a
        *can="{permission:item['permission']!=null? item['permission']:null,permissionType:'menu'}"
        [routerLink]="item.link"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        data-cy="templates">
          <i [class]="item.icon"></i> <span *ngIf="sidebarVisible">{{ item.label }}</span>
        </a>
  </span>

  </aside>
  <div class="main-content" [ngClass]="{ 'spread-out': !sidebarVisible, 'content-full-width': !sidebarVisible }">
    <router-outlet></router-outlet>
  </div>
</div>
